import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {SubsidyDossier} from './subsidy-dossier.model';
import {map} from 'rxjs/operators';
import {SubsidyType} from '../../models/subsidy-type.type';

@Injectable({
	providedIn: 'root',
})
export class SubsidyDossiersService {
	#http = inject(HttpClient);

	getSubsidyDossiers(): Observable<SubsidyDossier[]> {
		return this.#http.get<SubsidyDossier[]>('/api12/subsidyDossier').pipe(map((dossiers) => dossiers.map((d) => this.convertDossier(d))));
	}

	updateDossier(subsidyType: SubsidyType, id: number, data: any): Observable<SubsidyDossier> {
		return this.#http.post<SubsidyDossier>(`/api12/${subsidyType}/subsidyDossier/${id}`, data).pipe(map((d) => this.convertDossier(d)));
	}

	submitDossier(subsidyType: SubsidyType, id: number, types: string[]): Observable<any> {
		const params: any = {};

		types.forEach((type) => (params[type] = true));

		return this.#http.post(`/api12/${subsidyType}/subsidyDossier/${id}/submit`, {}, { params });
	}

	submitPaymentRequest(subsidyType: SubsidyType, id: number): Observable<any> {
		return this.#http.post(`/api12/${subsidyType}/subsidyDossier/${id}/paymentrequest/submit`, {});
	}

	submitReport(subsidyType: SubsidyType, id: number, report: any): Observable<any> {
		return this.#http.post(`/api12/${subsidyType}/subsidyDossier/${id}/progressreport/submit`, report);
	}

	private convertDossier(dossier: any): SubsidyDossier {
		return new SubsidyDossier({
			...dossier,
			attachments: dossier.attachments || [],
			requiredAttachments: dossier.requiredAttachments || [],
		});
	}
}
